__turbopack_context__.v({
  "gift-landing": "GiftRecipientLandingView-module-scss-module__Q-J1la__gift-landing",
});
